
import { $delay } from '@/common/utils';
import lazyInject from '@/di';
import PermissionService from '@/services/permission.service';

import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class AddRoleModal extends Vue {
  loading = false;

  @Prop()
  visible!: boolean;

  form = {
    name: '',
  };

  @Prop({
    default: () => {
      return '';
    },
  })
  organizationId!: string;

  @lazyInject(PermissionService)
  protected permissionService!: PermissionService;

  async submit() {
    if (!this.form.name || !this.organizationId) {
      return;
    }

    if (this.loading) {
      return;
    }

    try {
      this.loading = true;
      const res = await this.permissionService.createRoleOfOrganization(
        this.organizationId,
        this.form.name,
      );

      if (res) {
        this.$message.success('添加成功');

        await $delay(500);
        this.$emit('close', true);
      }
    } catch (error) {
      this.$message.info(`${error}`);
    } finally {
      this.loading = false;
    }
  }

  reset() {
    this.form = {
      name: '',
    };
  }
}
